<template>
  <div class="contai_h">
    <div class="cont_box">
      <el-tabs type="border-card" @tab-click="TabClick">
        <!-- 建当处理 -->
        <el-tab-pane label="建当处理">
          <!-- 标题 -->
          <div class="cont_head">
            <h2>建当处理：</h2>
          </div>
          <!-- 分割线 -->
          <div class="bord"></div>
          <!-- 建当填写表单 -->
          <div class="cont_bo">
            <div class="cont_b">
              <!-- 表单顶部日期选择器 -->
              <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="7"
                  ><h2>
                    票号：
                    <!-- <span>{{ pawnCode }}</span> -->

                    <el-input
                      placeholder="请输入票号"
                      v-model="input"
                      clearable
                      maxlength="10"
                      class="cont_input"
                    ></el-input>
                    <button @click="getPawnCode">测试请求企业端票号</button>
                  </h2></el-col
                >
                <el-col :span="4"
                  ><h2 class="row_te">
                    建当处理
                    <div class="row_t"></div></h2
                ></el-col>
                <el-col :span="8"
                  ><h2>建档日期：{{ deta }}</h2>
                </el-col>
              </el-row>

              <!-- 填写当户信息栏 -->
              <div class="cont_content">
                <div class="con">
                  <div class="cont_left">
                    <h3>
                      当户：<el-input
                        type="text"
                        placeholder="请输入当户姓名"
                        v-model="input_name"
                        maxlength="4"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                      <!-- <el-button @click="reaDcard">读取</el-button> -->
                    </h3>
                    <h3>
                      地址：<el-input
                        type="text"
                        placeholder="请输入当户证件地址"
                        v-model="input_add"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      证件类型：
                      <el-radio v-model="radio" label="身份证" border>身份证</el-radio>
                      <el-radio v-model="radio" label="其他" border>其他</el-radio>
                    </h3>
                  </div>
                  <div class="cont_right">
                    <h3>
                      电话：<el-input
                        type="text"
                        placeholder="请输入当户电话"
                        v-model="input_tel"
                        maxlength="11"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      物品种类：
                      <el-select
                        v-model="input_wu"
                        placeholder="请选择"
                        @change="valueData"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          class="con_texts"
                        >
                        </el-option>
                      </el-select>
                    </h3>
                    <h3>
                      证件号码：
                      <el-input
                        type="text"
                        placeholder="请输入证件号码"
                        v-model="input_idcard"
                        maxlength="18"
                        @change="IdCardBlur"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                      <el-button @click="GetHistory">历史查找</el-button>
                      <el-button @click="IdCardBlur">不良记录查找</el-button>
                    </h3>
                  </div>
                </div>

                <!-- 输入值，物品输入框 -->
                <div class="tables">
                  <div class="tab_item">
                    <h3>当物名称：</h3>
                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_input"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>

                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_inputa"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>

                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_inputaa"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>
                  </div>
                  <div class="tab_item">
                    <h3>规格/类型：</h3>
                    <!-- <el-input
                      placeholder="请输入规格"
                      v-model="tabs_inpu"
                      clearable
                      class="tables_inps"
                    ></el-input> -->

                    <el-autocomplete
                      class="tables_inps"
                      v-model="tabs_inpu"
                      :fetch-suggestions="querySearch"
                      placeholder="请选择规格"
                    >
                    </el-autocomplete>

                    <el-autocomplete
                      class="tables_inps"
                      v-model="tabs_inpua"
                      :fetch-suggestions="querySearch"
                      placeholder="请选择规格"
                    >
                    </el-autocomplete>
                    <el-autocomplete
                      class="tables_inps"
                      v-model="tabs_inpuaa"
                      :fetch-suggestions="querySearch"
                      placeholder="请选择规格"
                    >
                    </el-autocomplete>
                  </div>
                  <div class="tab_item">
                    <h3>数量：</h3>
                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inp"
                      clearable
                      class="tables_inps"
                      @input="test"
                    ></el-input>
                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inpa"
                      clearable
                      class="tables_inps"
                      @input="test"
                    ></el-input>
                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inpaa"
                      clearable
                      class="tables_inps"
                      @input="test"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>重量/g：</h3>
                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_in"
                      clearable
                      class="tables_inps"
                      @input="zltest"
                      @blur="oneInput('tabs_i')"
                    ></el-input>
                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_ina"
                      clearable
                      class="tables_inps"
                      @input="zltest"
                      @blur="oneInput('tabs_ia')"
                    ></el-input>
                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_inaa"
                      clearable
                      class="tables_inps"
                      @input="zltest"
                      @blur="oneInput('tabs_iaa')"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>典当价格/元：</h3>
                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_i"
                      clearable
                      class="tables_inps"
                      @input="tests"
                      @blur="twoInput('tabs_i')"
                    ></el-input>
                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_ia"
                      clearable
                      class="tables_inps"
                      @input="tests"
                      @blur="twoInput('tabs_ia')"
                    ></el-input>
                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_iaa"
                      clearable
                      class="tables_inps"
                      @input="tests"
                      @blur="twoInput('tabs_iaa')"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>典当单价：</h3>
                    <span class="tes">{{ dpria }}</span>
                    <span class="tes">{{ dprib }}</span>
                    <span class="tes">{{ dpric }}</span>
                  </div>
                  <div class="tab_item">
                    <h3>折当率/%：</h3>
                    <el-input
                      placeholder="请输入折当率"
                      v-model="tabs_ze"
                      class="tables_inps"
                      @blur="oneInput('tabs_i')"
                    ></el-input>
                    <el-input
                      placeholder="请输入折当率"
                      v-model="tabs_zea"
                      class="tables_inps"
                      @blur="oneInput('tabs_ia')"
                    ></el-input>
                    <el-input
                      placeholder="请输入折当率"
                      v-model="tabs_zeaa"
                      class="tables_inps"
                      @blur="oneInput('tabs_iaa')"
                    ></el-input>
                  </div>
                </div>

                <!-- 合计 -->
                <div class="total">
                  <table width="100%">
                    <tr>
                      <td width="70%">
                        <div
                          class="connai"
                          v-for="item in Jpri"
                          :key="item.__ob__.dep.id"
                        >
                          <el-dropdown @command="handleCommand" trigger="click">
                            <span class="el-dropdown-link">
                              切换种类<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="1053">黄金9999</el-dropdown-item>
                              <el-dropdown-item command="1054">黄金9995</el-dropdown-item>
                              <el-dropdown-item command="1052">白银T+D</el-dropdown-item>
                              <el-dropdown-item command="1056">铂金9995</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                          <span>更新时间：{{ item.uptime }}</span>
                          <span>上交所价格：{{ item.varietynm }} </span>
                          <span>昨日收盘价：{{ item.yesy_price }}</span>
                          <span>买入价：{{ item.buy_price }}</span>
                          <span> 当前实时价：{{ item.last_price }}</span>
                        </div>
                      </td>
                      <td>
                        <span class="tota_span">数量：{{ tol }}</span>
                      </td>
                      <td>
                        <span class="tota_span">重量：{{ zl + "g" }}</span>
                      </td>
                      <td>
                        <span class="tota_span">典当总金额：{{ pr + "元" }}</span>
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- 日期选择栏 -->
                <div class="block">
                  <h3>典当日期：</h3>
                  <el-date-picker
                    v-model="detavalue"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    @change="chang"
                  >
                  </el-date-picker>

                  <div class="fl_con">
                    <div class="fl">
                      <h3 class="con_rate">月费率：</h3>

                      <el-input
                        placeholder="请输入月费率"
                        v-model="tabs_yf"
                        clearable
                        class="tas"
                      ></el-input>
                      <h3 class="con_rate">月利率：</h3>
                      <el-input
                        placeholder="请输入月利率"
                        v-model="tabs_yl"
                        clearable
                        class="tas"
                      ></el-input>
                    </div>
                  </div>
                </div>

                <!-- 典当综合费 -->
                <div class="con_cost">
                  <span class="con_costo">
                    <h3>典当金额：{{ pr + "元" }}</h3>
                    <h3>典当天数：{{ det + "天" }}</h3>
                    <h3>参考综合费：{{ pri + "元" }}</h3>
                    <h3>参考利息：{{ lx + "元" }}</h3>
                  </span>
                  <span class="con_costt">
                    <h3>
                      典当综合费:
                      <el-input
                        placeholder="请输入综合费"
                        v-model="input_zh"
                        clearable
                        class="con_elinp"
                      >
                      </el-input>
                      元
                    </h3>
                    <h3>
                      典当利息:
                      <el-input
                        placeholder="请输入典当利息"
                        v-model="input_lx"
                        clearable
                        class="con_elinp"
                      >
                      </el-input>
                      元
                    </h3>
                  </span>
                </div>
                <!-- 评估意见 -->
                <div class="con_y">
                  <h3>评估意见/备注:</h3>
                  <el-input
                    placeholder="请输入评估意见或者备注"
                    v-model="input_yj"
                    clearable
                    class="con_yj"
                  >
                  </el-input>
                </div>
              </div>

              <!-- 经办信息 -->
              <div class="cont_jb">
                <span
                  ><h3>经办人：{{ agent }}</h3></span
                >

                <!-- 复核 -->
                <span class="cont_jbs">
                  <h3>复核：</h3>
                </span>

                <!-- 财务 -->
                <span class="cont_jbs">
                  <h3>财务：</h3>
                </span>
              </div>

              <div class="con_upload">
                <!-- 上传 -->
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :show-file-list="true"
                  :http-request="upload"
                  :on-preview="handlePictureCardPreview"
                  :before-remove="handleRemove"
                  :limit="2"
                  :before-upload="beforeAvatarUpload"
                >
                  <span v-if="uploadtype">
                    <el-progress type="circle" :percentage="uploadnum"></el-progress>
                  </span>
                  <span v-else>
                    <i class="el-icon-plus"></i>
                  </span>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </div>

              <!-- 提交按钮 -->
              <div class="foter">
                <el-button type="primary" @click="cont_Submit">提交</el-button>
              </div>
            </div>

            <!-- 弹窗提示 -->
            <el-dialog
              :title="'检测到 ' + badData.length + ' 条不良典当记录提醒'"
              :visible.sync="dialogTableDad"
              :before-close="DadClose"
            >
              <el-table :data="badData">
                <el-table-column
                  property="createDate"
                  label="添加日期"
                  width="150"
                ></el-table-column>
                <el-table-column
                  property="name"
                  label="当户姓名"
                  width="200"
                ></el-table-column>
                <el-table-column
                  property="idcard"
                  label="证件号码"
                  width="200"
                ></el-table-column>
                <el-table-column property="content" label="不良记录"></el-table-column>
                <el-table-column property="addname" label="添加人"></el-table-column>
              </el-table>
            </el-dialog>
          </div>
        </el-tab-pane>

        <!-- 断当回收 -->
        <el-tab-pane label="断当回收">
          <!-- 标题 -->
          <div class="cont_head">
            <h2>断当回收：</h2>
          </div>
          <!-- 分割线 -->
          <div class="bord"></div>
          <!-- 线框 -->
          <div class="cont_bo">
            <div class="cont_b">
              <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="7"
                  ><h2>
                    票号：
                    {{ input_pnum }}
                    <!-- <el-input
                      placeholder="请输入票号"
                      v-model="input_pnum"
                      clearable
                      maxlength="10"
                      class="cont_input"
                    ></el-input> -->
                  </h2></el-col
                >
                <el-col :span="4"
                  ><h2 class="row_te">
                    断当回收
                    <div class="row_t"></div></h2
                ></el-col>
                <el-col :span="8"
                  ><h2>建档日期：{{ deta }}</h2>
                </el-col>
              </el-row>

              <div class="cont_contes">
                <div class="cons_cos">
                  <div class="cont_lefts">
                    <h3>
                      当户：<el-input
                        type="text"
                        placeholder="请输入当户姓名"
                        v-model="input_names"
                        maxlength="5"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      地址：<el-input
                        type="text"
                        placeholder="请输入当户证件地址"
                        v-model="input_adds"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      证件类型：
                      <el-radio v-model="radios" label="身份证" border>身份证</el-radio>
                      <el-radio v-model="radios" label="其他" border>其他</el-radio>
                    </h3>
                  </div>
                  <div class="cont_rights">
                    <h3>
                      电话：<el-input
                        type="text"
                        placeholder="请输入当户电话"
                        v-model="input_tels"
                        maxlength="11"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      物品种类：
                      <el-select
                        v-model="input_wus"
                        placeholder="请选择"
                        @change="valueDa"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          class="con_texts"
                        >
                        </el-option>
                      </el-select>
                    </h3>
                    <h3>
                      证件号码：
                      <el-input
                        type="text"
                        placeholder="请输入证件号码"
                        v-model="input_idcards"
                        maxlength="18"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                  </div>
                </div>
                <!-- 输入值 -->
                <div class="tables">
                  <div class="tab_item">
                    <!-- 第一栏 -->
                    <h3>当物名称：</h3>
                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_inputs"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>

                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_inputsa"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>

                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_inputsaa"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>
                  </div>
                  <div class="tab_item">
                    <h3>规格/类型：</h3>

                    <el-select
                      v-model="tabs_inpus"
                      clearable
                      placeholder="请选择"
                      class="tables_inps"
                    >
                      <el-option
                        v-for="item in opt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      v-model="tabs_inpusa"
                      clearable
                      placeholder="请选择"
                      class="tables_inps"
                    >
                      <el-option
                        v-for="item in opt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      v-model="tabs_inpusaa"
                      clearable
                      placeholder="请选择"
                      class="tables_inps"
                    >
                      <el-option
                        v-for="item in opt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="tab_item">
                    <h3>数量：</h3>
                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inps"
                      clearable
                      class="tables_inps"
                    ></el-input>

                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inpsa"
                      clearable
                      class="tables_inps"
                    ></el-input>

                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_inpsaa"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>重量/g：</h3>
                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_ins"
                      clearable
                      class="tables_inps"
                    ></el-input>

                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_insa"
                      clearable
                      class="tables_inps"
                    ></el-input>

                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_insaa"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>回收价格：</h3>
                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_is"
                      clearable
                      class="tables_inps"
                      @blur="twosInput('tabs_ins')"
                    ></el-input>

                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_isa"
                      clearable
                      class="tables_inps"
                      @blur="twosInput('tabs_insa')"
                    ></el-input>

                    <el-input
                      type="number"
                      placeholder="请输入价格"
                      v-model="tabs_isaa"
                      clearable
                      class="tables_inps"
                      @blur="twosInput('tabs_insaa')"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>回收单价</h3>
                    <span class="tes">{{ hpria }}</span>
                    <span class="tes">{{ hprib }}</span>
                    <span class="tes">{{ hpric }}</span>
                  </div>
                  <div class="tab_item">
                    <h3>折当率/%:</h3>

                    <el-input
                      placeholder="请输入折当率"
                      v-model="hs_ze"
                      class="tables_inps"
                      @blur="onesInput('tabs_ins')"
                    ></el-input>

                    <el-input
                      placeholder="请输入折当率"
                      v-model="hs_zea"
                      class="tables_inps"
                      @blur="onesInput('tabs_insa')"
                    ></el-input>

                    <el-input
                      placeholder="请输入折当率"
                      v-model="hs_zeaa"
                      class="tables_inps"
                      @blur="onesInput('tabs_insaa')"
                    ></el-input>
                  </div>
                </div>

                <!-- 上交所金价 -->
                <div class="conn" v-for="item in Jpri" :key="item.__ob__.dep.id">
                  <el-dropdown @command="handleCommand" trigger="click">
                    <span class="el-dropdown-link">
                      切换种类<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1053">黄金9999</el-dropdown-item>
                      <el-dropdown-item command="1054">黄金9995</el-dropdown-item>
                      <el-dropdown-item command="1052">白银T+D</el-dropdown-item>
                      <el-dropdown-item command="1056">铂金9995</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span>更新时间：{{ item.uptime }}</span>
                  <span>上交所价格：{{ item.varietynm }} </span>
                  <span>昨日收盘价：{{ item.yesy_price }}</span>
                  <span>买入价：{{ item.buy_price }}</span>
                  <span> 当前实时价：{{ item.last_price }}</span>
                </div>

                <!-- 小计 -->
                <div class="zon">
                  <span
                    >总数量：{{
                      Number(tabs_inps) + Number(tabs_inpsa) + Number(tabs_inpsaa)
                    }}
                    ,</span
                  >
                  <span
                    >总重量：{{
                      (Number(tabs_ins) + Number(tabs_insa) + Number(tabs_insaa)).toFixed(
                        2
                      )
                    }}
                    /g,</span
                  >
                  <span
                    >总金额：{{
                      Number(tabs_is) + Number(tabs_isa) + Number(tabs_isaa)
                    }}
                    元</span
                  >
                </div>

                <!-- 支付备注 -->
                <div class="conts_zf">
                  <h3>回收日期: {{ deta }}</h3>
                  <h3>备注:</h3>
                  <el-input
                    placeholder="请输入内容"
                    v-model="inputzf"
                    clearable
                    class="cont_zfin"
                  >
                  </el-input>
                </div>
              </div>

              <!-- 经办信息 -->
              <div class="cont_jb">
                <span
                  ><h3>经办人：{{ agent }}</h3></span
                >

                <!-- 复核 -->
                <span class="cont_jbs">
                  <h3>复核：</h3>
                </span>

                <!-- 财务 -->
                <span class="cont_jbs">
                  <h3>财务：</h3>
                </span>
              </div>
              <!-- 上传图片 -->
              <div class="con_upload">
                <!-- 上传 -->
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :show-file-list="true"
                  :http-request="upload"
                  :on-preview="handlePictureCardPreview"
                  :before-remove="handleRemove"
                  :limit="6"
                  :before-upload="beforeAvatarUpload"
                >
                  <span v-if="uploadtype">
                    <el-progress type="circle" :percentage="uploadnum"></el-progress>
                  </span>
                  <span v-else>
                    <i class="el-icon-plus"></i>
                  </span>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </div>

              <!-- 提交按钮 -->
              <div class="foter">
                <el-button type="primary" @click="cont_Submits">提交</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 鉴定评估 -->
        <el-tab-pane label="鉴定评估">
          <!-- 标题 -->
          <div class="cont_head">
            <h2>鉴定评估：</h2>
          </div>
          <!-- 分割线 -->
          <div class="bord"></div>
          <div class="cont_bo">
            <div class="cont_b">
              <div class="cont_contes">
                <div class="cons_cos">
                  <div class="cont_lefts">
                    <h3>
                      当户：<el-input
                        type="text"
                        placeholder="请输入当户姓名"
                        v-model="input_jnames"
                        maxlength="5"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      地址：<el-input
                        type="text"
                        placeholder="请输入当户证件地址"
                        v-model="input_jadds"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      证件类型：
                      <el-radio v-model="radiojs" label="身份证" border>身份证</el-radio>
                      <el-radio v-model="radiojs" label="其他" border>其他</el-radio>
                    </h3>
                  </div>
                  <div class="cont_rights">
                    <h3>
                      电话：<el-input
                        type="text"
                        placeholder="请输入当户电话"
                        v-model="input_jtels"
                        maxlength="11"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                    <h3>
                      物品类型：
                      <el-select v-model="input_jwus" placeholder="请选择">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          class="con_texts"
                        >
                        </el-option>
                      </el-select>
                    </h3>
                    <h3>
                      证件号码：
                      <el-input
                        type="text"
                        placeholder="请输入证件号码"
                        v-model="input_jidcards"
                        maxlength="18"
                        clearable
                        class="con_texts"
                      >
                      </el-input>
                    </h3>
                  </div>
                </div>

                <!-- 输入值 -->
                <div class="tables">
                  <div class="tab_item">
                    <h3>当物名称：</h3>
                    <el-input
                      placeholder="请输入名称"
                      v-model="tabs_jinputs"
                      clearable
                      class="tables_inps"
                    >
                    </el-input>
                  </div>
                  <div class="tab_item">
                    <h3>规格/状况：</h3>
                    <el-input
                      placeholder="请输入规格"
                      v-model="tabs_jinpus"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>数量：</h3>
                    <el-input
                      type="number"
                      placeholder="请输入数量"
                      v-model="tabs_jinps"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>重量/g：</h3>
                    <el-input
                      placeholder="请输入重量"
                      v-model="tabs_jins"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                  <div class="tab_item">
                    <h3>鉴定备注：</h3>
                    <el-input
                      placeholder="请输入备注"
                      v-model="tabs_jis"
                      clearable
                      class="tables_inps"
                    ></el-input>
                  </div>
                </div>

                <!-- 鉴定日期 -->
                <div class="conts_zf">
                  <h3>鉴定日期: {{ deta }}</h3>
                  <h3>已收鉴定费:</h3>
                  <el-input
                    placeholder="请输入鉴定费"
                    v-model="inputjd"
                    clearable
                    class="cont_jdf"
                  >
                  </el-input>
                </div>
              </div>
              <!-- 经办信息 -->
              <div class="cont_jb">
                <span
                  ><h3>经办人：{{ agent }}</h3></span
                >

                <!-- 复核 -->
                <span class="cont_jbs">
                  <h3>复核：</h3>
                </span>

                <!-- 财务 -->
                <span class="cont_jbs">
                  <h3>财务：</h3>
                </span>
              </div>

              <!-- 提交按钮 -->
              <div class="foter">
                <el-button type="primary" @click="cont_Submitjs">提交</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 历史典当弹窗 -->
      <el-dialog
        title="历史典当"
        :visible.sync="dialogTableVisible"
        :before-close="handleClose"
        width="60%"
      >
        <div>
          <GetHistory :historyList="newHistoryList" @child-event="childData"></GetHistory>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import util from "@/components/util";
import GetHistory from "@/components/dialogGetHistory/GetHistory";
const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});
// import qs from "qs";
export default {
  name: "establish",

  components: {
    GetHistory,
  },
  data() {
    return {
      input: "", //建当的票号
      input_pnum: "", //回收的票号
      deta: "", //建档的日期
      token: "", //token
      input_name: "", //当户姓名
      input_names: "", //回收当户姓名
      input_add: "", //当户地址
      input_adds: "", //回收当户地址
      input_tel: "", //当户电话
      input_tels: "", //回收当户电话
      tabs_ze: "85", //建当折当率
      input_wu: "", //物品名称
      input_wus: "", //回收物品名称
      input_idcard: "", //证件号码
      input_idcards: "", //回收证件号码
      radio: "身份证", //证件类型默认值
      radios: "身份证", //回收类型默认值
      tabs_input: "", //当物名称值
      tabs_inputs: "", //回收第一栏名称
      tabs_inputsa: "", //回收第二栏名称
      tabs_inputsaa: "", //回收第三栏名称
      tabs_inpu: "", //当物规格值
      tabs_inpus: "", //回收第一栏 规格
      tabs_inpusa: "", //回收第二栏规格
      tabs_inpusaa: "", //回收第三栏规格
      tabs_inp: 1, //当物数量值
      tabs_inps: "", //回收第一栏数量
      tabs_inpsa: "", //回收第二栏数量
      tabs_inpsaa: "", //回收第三栏数量
      tabs_in: "", //当物重量
      tabs_ins: "", //回收第一栏重量
      tabs_insa: "", //回收第二栏重量
      tabs_insaa: "", //回收第三栏重量
      tabs_i: "", //当物估价值
      input_yj: "", //评估意见
      tabs_is: "", //回收第一栏价格
      tabs_isa: "", //回收第二栏价格
      tabs_isaa: "", //回收第三栏价格
      detavalue: "", //选择典当日期
      pickerOptions: {
        shortcuts: [
          {
            text: "15天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "60天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "30天(非会员)",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // const test = "bz";
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      //选择物品类型
      options: [
        {
          value: "黄金",
          label: "黄金",
        },
        {
          value: "铂金",
          label: "铂金",
        },
        {
          value: "k金",
          label: "k金",
        },
        {
          value: "银",
          label: "银",
        },
        {
          value: "钯金",
          label: "钯金",
        },
        {
          value: "手表",
          label: "手表",
        },
        {
          value: "电子产品",
          label: "电子产品",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],

      //回收物品的下拉选项
      opt: [
        {
          value: "黄金9999",
          label: "黄金9999",
        },
        {
          value: "黄金9995",
          label: "黄金9995",
        },
        {
          value: "铂金9995",
          label: "铂金9995",
        },
        {
          value: "K金",
          label: "K金",
        },
        {
          value: "钯金",
          label: "钯金",
        },
        {
          value: "手表",
          label: "手表",
        },
        {
          value: "电子产品",
          label: "电子产品",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],

      mode: "", //付款方式
      // input_bank: "", //开户行
      // input_banks: "", //银行账号
      // dis: false, //银行信息输入框默认不显示
      agent: "", //经办人名字
      review: "", //复核名字
      finance: "", //财务名字
      warehouse: "", //仓管名字
      dialogImageUrl: "", //element 上传字段
      dialogVisible: false, //element 上传字段
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      input_zh: "", //输入典当综合费值
      input_lx: 0, //输入框典当利息
      det: 0, //计算出典当天数
      dec: "", //减出来的天数
      pri: 0, //典当综合费
      lx: 0, //典当利息
      inputzf: "", //支付备注
      imags: "https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/jkjk.jpg", //当品图片
      imag: "https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/jkjk.jpg", //当票
      otherImg: "", //其他图片

      // 鉴定评估的数据
      input_jnames: "", //鉴定当户姓名
      input_jadds: "", //鉴定当户地址
      radiojs: "身份证", //鉴定当户证件类型
      input_jtels: "", //鉴定当户的电话
      input_jwus: "", //鉴定当户的物品名称
      input_jidcards: "", //证件号码
      tabs_jinputs: "", //物品名称
      tabs_jinpus: "", //规格
      tabs_jinps: "", //数量
      tabs_jins: "", //重量
      tabs_jis: "", //鉴定备注
      inputjd: "", //已收鉴定费

      // // 上传图片组件
      //   dialogImageUrl: '',
      //   dialogVisible: false
      imageUrl: "",

      //物品第二栏第三栏输入框的值
      tabs_inputa: "", //当物名称第二栏
      tabs_inputaa: "", //当物名称第三栏
      tabs_inpua: "", //规格第二栏
      tabs_inpuaa: "", //规格第三栏
      tabs_inpa: "", //数量第二栏
      tabs_inpaa: "", //数量第三栏
      tabs_ina: "", //重量第二栏
      tabs_inaa: "", //重量第三栏
      tabs_ia: "", //典当价格第二栏
      tabs_iaa: "", //典当价格第三栏
      tabs_zea: "", //折当率第二栏
      tabs_zeaa: "", //折当率第三栏

      pr: 0, //总金额
      tol: 1, //总数量
      zl: 0, //总重量

      tabs_yf: "", //月费率
      tabs_yl: "", //月利率
      Jpri: [], //实时价格数据包

      lists: false, //贵金属物品的下拉开关

      dpria: "计算中...", //建当的典当单价第一栏
      dprib: "计算中...", //建当的典当单价第二栏
      dpric: "计算中...", //建当的典当单价第三栏

      hpria: "计算中...", //回收的单价第一栏
      hprib: "计算中...", //回收的单价第二栏
      hpric: "计算中...", //回收的单价第三栏

      realprice1: "", //建当第一栏物品实时单价
      realprice2: "", //建当第二栏物品实时单价
      realprice3: "", //建当第三栏物品实时单价

      reaprice1: "", //回收第一栏物品实时单价
      reaprice2: "", //回收第二栏的物品实时单价
      reaprice3: "", //回收第三栏物品实时单价

      hs_ze: "", //回收第一栏的折当率
      hs_zea: "", //回收第二栏的折当率
      hs_zeaa: "", //回收第三栏的折当率

      //  dialogImageUrl: '',
      // dialogVisible: false
      Imgs: [], //物品图片
      uploadnum: "", //上传进度
      uploadtype: false, //是否显示进度

      dialogTableVisible: false, //历史典当弹窗开关

      newHistoryList: [],

      badData: [], //不良典当数据
      dialogTableDad: false, //不良典当弹窗

      pawnCode: "",
    };
  },

  methods: {
    //数量总和输入框值
    test() {
      this.tol = Number(this.tabs_inp) + Number(this.tabs_inpa) + Number(this.tabs_inpaa);
      // this.tol =
    },
    //典当金额总和
    tests() {
      this.pr = Math.floor(
        Number(this.tabs_i) + Number(this.tabs_ia) + Number(this.tabs_iaa)
      );
    },
    //重量的总和
    zltest() {
      this.zl = (
        Number(this.tabs_in) +
        Number(this.tabs_ina) +
        Number(this.tabs_inaa)
      ).toFixed(1);
    },

    //element 上传方法
    upload(res) {
      if (res.file) {
        console.log(res.file);
        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key: res.file.name /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: res.file, // 上传文件对象
            onProgress: (progressData) => {
              // 上传进度
              this.uploadnum = progressData.percent * 100;
            },
          },
          (err, data) => {
            // 上传成功之后
            if (data.statusCode == 200) {
              this.Imgs.push("https://" + data.Location);
              this.uploadtype = false;
            }
          }
        );
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload() {
      this.uploadtype = true;
    },

    // 删除钩子
    handleRemove(file) {
      cos
        .deleteObject({
          Bucket: "changan-1259114000" /* 填入您自己的存储桶，必须字段 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "文件删除成功",
            type: "success",
          });
        });
    },

    //点击计算综合费公式
    chang() {
      if (this.detavalue !== null) {
        this.dec = dayjs(this.detavalue[1]).add(1, "day").format("YYYY-MM-DD");
        this.det = dayjs(this.dec).diff(dayjs(this.detavalue[0]), "day");
      } else {
        (this.det = 0), (this.pri = 0), (this.lx = 0);
        this.tabs_yf = "";
        this.tabs_yl = "";
      }

      if (this.det == "15") {
        //当期选择为15天时
        this.pri = Math.trunc(this.pr * 0.0189); //15天典当综合费
        this.input_zh = Math.trunc(this.pr * 0.0189);
        this.lx = (this.pr * 0.0015).toFixed(2); //15天利息
        this.input_lx = (this.pr * 0.0015).toFixed(2);
        this.tabs_yf = "3.78%";
        this.tabs_yl = "0.28%";
      } else if (this.det == "30") {
        //当期选择为30天时
        this.pri = Math.trunc(this.pr * 0.025);
        this.input_zh = Math.trunc(this.pr * 0.025);
        this.lx = (this.pr * 0.0029).toFixed(2);
        this.input_lx = (this.pr * 0.0028).toFixed(2);
        this.tabs_yf = "2.5%";
        this.tabs_yl = "0.28%";
      } else if (this.det == "60") {
        //当期选择为60天时
        this.pri = Math.trunc(this.pr * 0.04);
        this.input_zh = Math.trunc(this.pr * 0.04);
        this.lx = (this.pr * 0.006).toFixed(2);
        this.input_lx = (this.pr * 0.006).toFixed(2);
        this.tabs_yf = "2%";
        this.tabs_yl = "0.28%";
      }
    },

    //建当
    cont_Submit() {
      //如果票号有重复或者没有输入票号时不能建当
      if (this.input == "") {
        return this.$message.error("请输入票号，才能建当");
      }

      //查询该票号是否有建过当
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").where({ticketnumber:"${this.input}"}).get()`,
        })
        .then((ras) => {
          if (ras.data.data.length >= 1) {
            //如果大于等于1，说明该票号有建当过则不能建当
            return this.$message.error("该票号已建当，不能重复建当");
          }
          //建当操作
          this.$confirm("确定要建当吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let yspri = Number(this.pri) + Number(this.lx);
              this.axios
                .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                  env: `${this.userData.env}`,
                  query:
                    'db.collection("add_data").add({data:{ticketnumber:"' +
                    this.input +
                    '",deta:"' +
                    this.deta +
                    '",name:"' +
                    this.input_name +
                    '",telnumber:"' +
                    this.input_tel +
                    '",address:"' +
                    this.input_add +
                    '",itemname:"' +
                    this.input_wu +
                    '",type:"' +
                    this.radio +
                    '",cardnumber:"' +
                    this.input_idcard +
                    '",objname:"' +
                    this.tabs_input +
                    '",speci:"' +
                    this.tabs_inpu +
                    '",number:"' +
                    this.tol +
                    '",weight:"' +
                    this.zl +
                    '",price:"' +
                    this.pr +
                    '",startdate:"' +
                    this.detavalue[0] +
                    '",enddate:"' +
                    this.detavalue[1] +
                    '",mode:"' +
                    this.mode +
                    '",days:"' +
                    this.det +
                    '",cost:"' +
                    this.input_zh +
                    '",review:"' +
                    this.review +
                    '",finance:"' +
                    this.finance +
                    '",agent:"' +
                    this.agent +
                    '",imags:"' +
                    this.imags +
                    '",imag:"' +
                    this.imag +
                    '",reviewImg:"' +
                    this.Imgs[0] +
                    '",reviewImgs:"' +
                    this.Imgs[1] +
                    '",otherImg:"' +
                    this.otherImg +
                    '",ticketImg:"",state:"在当",zpri:"' +
                    this.zpri +
                    '",isPay:"",reviewdate:"",whether:false,wareh:false,warehrname:"",warehcname:"",warehstat:"",opinion:"' +
                    this.input_yj +
                    '",compre:"否",rate:"' +
                    this.tabs_ze +
                    '",objnamea:"' +
                    this.tabs_inputa +
                    '",objnameaa:"' +
                    this.tabs_inputaa +
                    '",specia:"' +
                    this.tabs_inpua +
                    '",speciaa:"' +
                    this.tabs_inpuaa +
                    '",num:"' +
                    this.tabs_inp +
                    '",numa:"' +
                    this.tabs_inpa +
                    '",numaa:"' +
                    this.tabs_inpaa +
                    '",weig:"' +
                    this.tabs_in +
                    '",weiga:"' +
                    this.tabs_ina +
                    '",weigaa:"' +
                    this.tabs_inaa +
                    '",pric:"' +
                    this.tabs_i +
                    '",prica:"' +
                    this.tabs_ia +
                    '",pricaa:"' +
                    this.tabs_iaa +
                    '", ratea:"' +
                    this.tabs_zea +
                    '",rateaa:"' +
                    this.tabs_zeaa +
                    '",yfl:"' +
                    this.tabs_yf +
                    '",yll:"' +
                    this.tabs_yl +
                    '",lx:"' +
                    this.input_lx +
                    '",yspri:"' +
                    yspri +
                    '",realpricea:"' +
                    this.realprice1 +
                    '",realpriceaa:"' +
                    this.realprice2 +
                    '",realpriceaaa:"' +
                    this.realprice3 +
                    '",unitpricea:"' +
                    this.dpria +
                    '",unitpriceaa:"' +
                    this.dprib +
                    '",unitpriceaaa:"' +
                    this.dpric +
                    '",remit:"",time:"' +
                    dayjs().format("HH:mm") +
                    '"}})',
                })

                .then(() => {
                  //发送模板消息

                  this.$message({
                    type: "success",
                    message: "建当成功!",
                  });

                  //发送复核模板
                  this.sendInfoForm();

                  setTimeout(() => {
                    this.$router.go(0);
                  }, 2000);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消建当",
              });
            });
        });
    },

    //发送复核模板
    sendInfoForm() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weReviewTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.errcode == 0) {
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("weTemplate").where({}).get()`,
              })
              .then((re) => {
                re.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                this.axios
                  .get("/getToken/GetTokenGZH", {
                    params: {
                      id: re.data.data[0].gzhTokenID,
                      appid: re.data.data[0].mpappid,
                      secret: re.data.data[0].secret,
                    },
                  })
                  .then((r) => {
                    this.sendReview(res.data.data, r.data[0].AccessToken);
                  });
              });
          }

          // 推送复核提醒
          // for (let i = 0; i < res.data.data.length; i++) {
          //   util.sendInform(
          //     this.agent,
          //     this.input_name,
          //     this.tabs_input,
          //     this.pr,
          //     this.deta,
          //     this.ACCESS_TOKEN,
          //     this.input,
          //     this.input_zh,
          //     res.data.data[i]
          //   );
          // }
          // console.log(res.data.data[0])
          // this.axios.get("/getUser/GetTokenGZH").then(res=>{
          //   console.log('56566',res)
          // })

          //  util.sendInform(
          //       this.agent,
          //       this.input_name,
          //       this.tabs_input,
          //       this.pr,
          //       this.deta,
          //       '72_S9qzzxcUTGl6qzGoreeyKn0fo4U968T1sxRgHL5X6fYQADgboD1qRuYPeM4O8k4Gv5lgFV_O_DESxk0TyuwZyiF_Y8cv_RRYVJMt2TAmGucdrJxIVPtFWvGp7moMDYhAIAEVQ',
          //       this.input,
          //       this.input_zh,
          //       'oX_eOjszV5nuUo02_6HrAJQdYhNU'
          //     );
        });
    },
    sendReview(event, token) {
      // 推送复核提醒
      for (let i = 0; i < event.length; i++) {
        util.sendInform(
          this.agent,
          this.input_name,
          this.tabs_input,
          this.pr,
          this.deta,
          token,
          this.input,
          this.input_zh,
          event[i]
        );
      }
    },

    // 断当收回
    cont_Submits() {
      //收回物品添加到数据库
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("take_back").add({data:{input_pnum:"' +
            this.input_pnum +
            '",input_names:"' +
            this.input_names +
            '",input_adds:"' +
            this.input_adds +
            '",radios:"' +
            this.radios +
            '",input_tels:"' +
            this.input_tels +
            '",input_wus:"' +
            this.input_wus +
            '",input_idcards:"' +
            this.input_idcards +
            '",tabs_inputs:"' +
            this.tabs_inputs +
            '",tabs_inpus:"' +
            this.tabs_inpus +
            '",tabs_inps:"' +
            this.tabs_inps +
            '",tabs_ins:"' +
            this.tabs_ins +
            '",tabs_is:"' +
            this.tabs_is +
            '",deta:"' +
            this.deta +
            '",inputzf:"' +
            this.inputzf +
            '",whether:false,agent:"' +
            this.agent +
            '",review:"' +
            this.review +
            '",finance:"' +
            this.finance +
            '",wareh:false,reviewdate:"",warehrname:"",warehcname:"",warehstat:"",hpria:"' +
            this.hpria +
            '",hs_ze:"' +
            this.hs_ze +
            '",tabs_inputsa:"' +
            this.tabs_inputsa +
            '",tabs_inpusa:"' +
            this.tabs_inpusa +
            '",tabs_inpsa:"' +
            this.tabs_inpsa +
            '",tabs_insa:"' +
            this.tabs_insa +
            '",tabs_isa:"' +
            this.tabs_isa +
            '",hprib:"' +
            this.hprib +
            '",hs_zea:"' +
            this.hs_zea +
            '",tabs_inputsaa:"' +
            this.tabs_inputsaa +
            '",tabs_inpusaa:"' +
            this.tabs_inpusaa +
            '",tabs_inpsaa:"' +
            this.tabs_inpsaa +
            '",tabs_insaa:"' +
            this.tabs_insaa +
            '",tabs_isaa:"' +
            this.tabs_isaa +
            '",hpric:"' +
            this.hpric +
            '",hs_zeaa:"' +
            this.hs_zeaa +
            '",reaprice1:"' +
            this.reaprice1 +
            '",reaprice2:"' +
            this.reaprice2 +
            '",reaprice3:"' +
            this.reaprice3 +
            '",reviewImg1:"' +
            this.Imgs +
            '",time:"' +
            dayjs().format("HH:mm") +
            '"}})',
        })
        .then((ra) => {
          if (ra.data.errcode == 0) {
            this.$notify({
              title: "成功",
              message: "断当回收建当成功",
              type: "success",
            });
            this.sendRecycleInForms();
            // util.sendRecycleInform(
            //   this.agent,
            //   this.input_names,
            //   this.tabs_inputs,
            //   Number(this.tabs_is) + Number(this.tabs_isa) + Number(this.tabs_isaa),
            //   Number(this.tabs_ins) + Number(this.tabs_insa) + Number(this.tabs_insaa),
            //   this.deta,
            //   this.ACCESS_TOKEN,
            //   this.input_pnum
            // );
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          } else {
            this.$notify.error({
              title: "错误",
              message: "断当回收建当错误，请检查token是否过期",
            });
          }
        });
    },

    //发送回收复核微信通知
    sendRecycleInForms() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("weReviewTemplate").where({}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (res.data.errcode == 0) {
            this.axios
              .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("weTemplate").where({}).get()`,
              })
              .then((re) => {
                re.data.data.forEach((element, index, array) => {
                  array[index] = JSON.parse(element);
                });

                this.axios
                  .get("/getToken/GetTokenGZH", {
                    params: {
                      id: re.data.data[0].gzhTokenID,
                      appid: re.data.data[0].mpappid,
                      secret: re.data.data[0].secret,
                    },
                  })
                  .then((r) => {
                    this.sendReviewHs(res.data.data, r.data[0].AccessToken);
                  });
              });
          }
        });
    },
    //发送回收复核模板
    sendReviewHs(event, token) {
      for (let i = 0; i < event.length; i++) {
        util.sendRecycleInform(
          this.agent,
          this.input_names,
          this.tabs_inputs,
          Number(this.tabs_is) + Number(this.tabs_isa) + Number(this.tabs_isaa),
          (
            Number(this.tabs_ins) +
            Number(this.tabs_insa) +
            Number(this.tabs_insaa)
          ).toFixed(2),
          this.deta,
          token,
          this.input_pnum,
          event[i]
        );
      }
    },

    // 鉴定评估
    cont_Submitjs() {
      //提交鉴定评估信息
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("ass_ment").add({data:{name:"' +
            this.input_jnames +
            '",adds:"' +
            this.input_jadds +
            '",radio:"' +
            this.radiojs +
            '",input_tel:"' +
            this.input_jtels +
            '",input_wu:"' +
            this.input_jwus +
            '",input_idcard:"' +
            this.input_jidcards +
            '",tabs_inpus:"' +
            this.tabs_jinpus +
            '",tabs_inps:"' +
            this.tabs_jinps +
            '",tabs_ins:"' +
            this.tabs_jins +
            '",tabs_is:"' +
            this.tabs_jis +
            '",inputjd:"' +
            this.inputjd +
            '",deta:"' +
            this.deta +
            '",whether:false,agent:"' +
            this.agent +
            '",review:"' +
            this.review +
            '",finance:"' +
            this.finance +
            '",reviewdate:""}})',
        })
        .then((rrf) => {
          if (rrf.data.errcode == 0) {
            this.$notify({
              title: "创建成功",
              message: "鉴定评估订单创建成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          } else {
            this.$notify.error({
              title: "错误",
              message: "鉴定评估订单创建错误，请检查token是否过期",
            });
          }
        });
      //
    },

    //读取身份证信息
    reaDcard() {
      this.axios
        .get("http://127.0.0.1:19196/readcard", {
          params: {
            t: Math.random(),
          },
        })
        .then((read) => {
          if (read.data.errorMsg == "读卡成功") {
            (this.input_idcard = read.data.certNumber),
              (this.input_name = read.data.partyName),
              (this.input_add = read.data.certAddress);

            return;
          }
          if (read.data.resultFlag == "-11") {
            this.$notify.error({
              title: read.data.errorMsg,
              message: "未识别到身份证，请放入有效身份证",
            });
            return;
          }
          if (read.data.resultFlag == "-3") {
            this.$notify.error({
              title: read.data.errorMsg,
              message: "身份证阅读器连接失败，请重新连接机器",
            });
          }
        });
    },
    //获取上海交易所实时金价
    getJpri(num) {
      this.axios
        .get("/getGold/?app=finance.gold_price", {
          params: {
            goldid: num,
            version: 3,
            appkey: "62349",
            sign: "2b467d69432566985eec8e93f82e9008",
            format: "json",
          },
        })
        .then((res) => {
          this.Jpri = res.data.result.dtList;
        });
    },
    //切换物品类型请求数据
    handleCommand(command) {
      this.getJpri(command);
    },
    //选择分类回调事件
    valueData(e) {
      if (e !== "其他" && e !== "手表" && e !== "电子产品") {
        this.getJpri("1053");
        this.lists = true;
      } else {
        this.Jpri = [];
      }
    },

    //选择回收物品种类
    valueDa(e) {
      if (e !== "其他" && e !== "手表" && e !== "电子产品") {
        this.getJpri("1053");
        this.lists = true;
      } else {
        this.Jpri = [];
      }
    },

    //
    oneInput(e) {
      //第一步筛选物品种类是否为黄金，铂金，如果不是则不参与自动计算
      if (this.input_wu == "黄金" || this.input_wu == "铂金" || this.input_wu !== "") {
        //新修改的代码
        if (e == "tabs_i") {
          //如果是第一栏时
          if (this.tabs_inpu == "黄金9999") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice1 = res.data.result.dtList[1053].last_price;
                this.tabs_i = Math.floor(
                  (res.data.result.dtList[1053].last_price *
                    this.tabs_in *
                    this.tabs_ze) /
                    100
                );
                this.dpria = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.tabs_ze) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpu == "黄金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice1 = res.data.result.dtList[1054].last_price;
                this.tabs_i = Math.floor(
                  (res.data.result.dtList[1054].last_price *
                    this.tabs_in *
                    this.tabs_ze) /
                    100
                );
                this.dpria = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.tabs_ze) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpu == "铂金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice1 = res.data.result.dtList[1056].last_price;
                this.tabs_i = Math.floor(
                  (res.data.result.dtList[1056].last_price *
                    this.tabs_in *
                    this.tabs_ze) /
                    100
                );
                this.dpria = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.tabs_ze) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else {
            this.realprice1 = "/";
            this.tabs_i = 0;
            this.dpria = "0";
            this.tests();
          }
        } else if (e == "tabs_ia") {
          //如果时第二栏时
          if (this.tabs_inpua == "黄金9999") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice2 = res.data.result.dtList[1053].last_price;
                this.tabs_ia = Math.floor(
                  (res.data.result.dtList[1053].last_price *
                    this.tabs_ina *
                    this.tabs_zea) /
                    100
                );
                this.dprib = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.tabs_zea) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpua == "黄金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice2 = res.data.result.dtList[1054].last_price;
                this.tabs_ia = Math.floor(
                  (res.data.result.dtList[1054].last_price *
                    this.tabs_ina *
                    this.tabs_zea) /
                    100
                );
                this.dprib = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.tabs_zea) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpua == "铂金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice2 = res.data.result.dtList[1056].last_price;
                this.tabs_ia = Math.floor(
                  (res.data.result.dtList[1056].last_price *
                    this.tabs_ina *
                    this.tabs_zea) /
                    100
                );
                this.dprib = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.tabs_zea) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else {
            this.realprice2 = "/";
            this.tabs_ia = 0;
            this.dprib = "0";
            this.tests();
          }
        } else if (e == "tabs_iaa") {
          //如果是第三栏时
          if (this.tabs_inpuaa == "黄金9999") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice3 = res.data.result.dtList[1053].last_price;
                this.tabs_iaa = Math.floor(
                  (res.data.result.dtList[1053].last_price *
                    this.tabs_inaa *
                    this.tabs_zeaa) /
                    100
                );
                this.dpric = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.tabs_zeaa) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpuaa == "黄金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice3 = res.data.result.dtList[1054].last_price;
                this.tabs_iaa = Math.floor(
                  (res.data.result.dtList[1054].last_price *
                    this.tabs_inaa *
                    this.tabs_zeaa) /
                    100
                );
                this.dpric = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.tabs_zeaa) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else if (this.tabs_inpuaa == "铂金9995") {
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.realprice3 = res.data.result.dtList[1056].last_price;
                this.tabs_iaa = Math.floor(
                  (res.data.result.dtList[1056].last_price *
                    this.tabs_inaa *
                    this.tabs_zeaa) /
                    100
                );
                this.dpric = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.tabs_zeaa) / 100)
                ).toFixed(0);
                this.tests();
              });
          } else {
            this.realprice3 = "/";
            this.tabs_iaa = 0;
            this.dpric = "0";
            this.tests();
          }
        }
      } else {
        this.$message.error("物品种类不能为空，除黄金、铂金，其他物品暂不能自动计算");
      }
    },

    //回收的折当率事件回调
    onesInput(e) {
      //回收物品类型如果是黄金，铂金执行
      if (this.input_wus == "黄金" || this.input_wus == "铂金" || this.input_wus !== "") {
        if (e == "tabs_ins") {
          //如果输入的时第一栏时
          if (this.tabs_inpus == "黄金9999") {
            //如果第一栏是黄金9999时
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice1 = res.data.result.dtList[1053].last_price;
                this.tabs_is = Math.floor(
                  (res.data.result.dtList[1053].last_price * this.tabs_ins * this.hs_ze) /
                    100
                );

                this.hpria = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.hs_ze) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpus == "黄金9995") {
            //如果第一栏是黄金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice1 = res.data.result.dtList[1054].last_price;
                this.tabs_is = Math.floor(
                  (res.data.result.dtList[1054].last_price * this.tabs_ins * this.hs_ze) /
                    100
                );
                this.hpria = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.hs_ze) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpus == "铂金9995") {
            //如果第一栏是铂金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice1 = res.data.result.dtList[1056].last_price;
                this.tabs_is = Math.floor(
                  (res.data.result.dtList[1056].last_price * this.tabs_ins * this.hs_ze) /
                    100
                );
                this.hpria = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.hs_ze) / 100)
                ).toFixed(0);
              });
          } else {
            //如果第一栏非黄金铂金时
            this.reaprice1 = "/";
            this.tabs_is = 0;
            this.hpria = "0";
          }
        } else if (e == "tabs_insa") {
          //如果输入的是第二栏时
          if (this.tabs_inpusa == "黄金9999") {
            //如果第二栏是黄金9999时
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice2 = res.data.result.dtList[1053].last_price;
                this.tabs_isa = Math.floor(
                  (res.data.result.dtList[1053].last_price *
                    this.tabs_insa *
                    this.hs_zea) /
                    100
                );
                this.hprib = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.hs_zea) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpusa == "黄金9995") {
            //如果第二栏是黄金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice2 = res.data.result.dtList[1054].last_price;
                this.tabs_isa = Math.floor(
                  (res.data.result.dtList[1054].last_price *
                    this.tabs_insa *
                    this.hs_zea) /
                    100
                );
                this.hprib = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.hs_zea) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpusa == "铂金9995") {
            //如果第二栏是铂金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice2 = res.data.result.dtList[1056].last_price;
                this.tabs_isa = Math.floor(
                  (res.data.result.dtList[1056].last_price *
                    this.tabs_insa *
                    this.hs_zea) /
                    100
                );
                this.hprib = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.hs_zea) / 100)
                ).toFixed(0);
              });
          } else {
            //如果第二栏非黄金铂金时
            this.reaprice2 = "/";
            this.tabs_isa = 0;
            this.hprib = "0";
          }
        } else if (e == "tabs_insaa") {
          //如果输入的是第三栏时
          if (this.tabs_inpusaa == "黄金9999") {
            //如果第三栏是黄金9999时
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1053",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice3 = res.data.result.dtList[1053].last_price;
                this.tabs_isaa = Math.floor(
                  (res.data.result.dtList[1053].last_price *
                    this.tabs_insaa *
                    this.hs_zeaa) /
                    100
                );
                this.hpric = (
                  res.data.result.dtList[1053].last_price *
                  (Number(this.hs_zeaa) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpusaa == "黄金9995") {
            //如果第三栏是黄金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1054",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice3 = res.data.result.dtList[1054].last_price;
                this.tabs_isaa = Math.floor(
                  (res.data.result.dtList[1054].last_price *
                    this.tabs_insaa *
                    this.hs_zeaa) /
                    100
                );
                this.hpric = (
                  res.data.result.dtList[1054].last_price *
                  (Number(this.hs_zeaa) / 100)
                ).toFixed(0);
              });
          } else if (this.tabs_inpusaa == "铂金9995") {
            //如果第三栏是铂金9995
            this.axios
              .get("/getGold/?app=finance.gold_price", {
                params: {
                  goldid: "1056",
                  version: 3,
                  appkey: "62349",
                  sign: "2b467d69432566985eec8e93f82e9008",
                  format: "json",
                },
              })
              .then((res) => {
                this.reaprice3 = res.data.result.dtList[1056].last_price;
                this.tabs_isaa = Math.floor(
                  (res.data.result.dtList[1056].last_price *
                    this.tabs_insaa *
                    this.hs_zeaa) /
                    100
                );
                this.hpric = (
                  res.data.result.dtList[1056].last_price *
                  (Number(this.hs_zeaa) / 100)
                ).toFixed(0);
              });
          } else {
            //如果第三栏非黄金铂金时
            this.reaprice3 = "/";
            this.tabs_isaa = 0;
            this.hpric = "0";
          }
        }
      } else {
        this.$message.error("物品种类不能为空，除黄金、铂金，其他物品暂不能自动计算");
      }
    },

    //根据典当价格计算单价和折当率
    twoInput(datas) {
      //第一步筛选物品种类是否为黄金，铂金，如果不是则不参与自动计算

      //根据典当价格计算单价和折当率
      if (datas == "tabs_i" && this.tabs_in !== "") {
        //如果是第一栏时且重量不为空时
        if (this.tabs_inpu == "黄金9999") {
          //如果第一栏是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpria = (Number(this.tabs_i) / Number(this.tabs_in)).toFixed(0); //计算第第一栏的单价
              this.tabs_ze =
                (
                  Number(this.tabs_i) /
                  Number(this.tabs_in) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpu == "黄金9995") {
          //如果一栏是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpria = (Number(this.tabs_i) / Number(this.tabs_in)).toFixed(2); //计算第第一栏的单价
              this.tabs_ze =
                (
                  Number(this.tabs_i) /
                  Number(this.tabs_in) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpu == "铂金9995") {
          //如果第一栏时铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpria = (Number(this.tabs_i) / Number(this.tabs_in)).toFixed(2); //计算第第一栏的单价
              this.tabs_ze =
                (
                  Number(this.tabs_i) /
                  Number(this.tabs_in) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果非黄金铂金时
          this.dpria = (Number(this.tabs_i) / Number(this.tabs_in)).toFixed(2); //计算第第一栏的单价
          this.tabs_ze = "0";
        }
      } else if (datas == "tabs_ia" && this.tabs_ina !== "") {
        //如果是第二栏时，且重量不为空时
        if (this.tabs_inpua == "黄金9999") {
          //如果第二栏是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dprib = (Number(this.tabs_ia) / Number(this.tabs_ina)).toFixed(0); //计算第第一栏的单价
              this.tabs_zea =
                (
                  Number(this.tabs_ia) /
                  Number(this.tabs_ina) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpua == "黄金9995") {
          //如果二栏是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dprib = (Number(this.tabs_ia) / Number(this.tabs_ina)).toFixed(2); //计算第第一栏的单价
              this.tabs_zea =
                (
                  Number(this.tabs_ia) /
                  Number(this.tabs_ina) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpua == "铂金9995") {
          //如果第二栏时铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dprib = (Number(this.tabs_ia) / Number(this.tabs_ina)).toFixed(2); //计算第第一栏的单价
              this.tabs_zea =
                (
                  Number(this.tabs_ia) /
                  Number(this.tabs_ina) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果非黄金铂金时
          this.dprib = (Number(this.tabs_ia) / Number(this.tabs_ina)).toFixed(2); //计算第第一栏的单价
          this.tabs_zea = "0";
        }
      } else if (datas == "tabs_iaa" && this.tabs_inaa !== "") {
        //如果是第三栏时，且重量不为空时
        if (this.tabs_inpuaa == "黄金9999") {
          //如果第三栏是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpric = (Number(this.tabs_iaa) / Number(this.tabs_inaa)).toFixed(0); //计算第第一栏的单价
              this.tabs_zeaa =
                (
                  Number(this.tabs_iaa) /
                  Number(this.tabs_inaa) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(0) * 100;
            });
        } else if (this.tabs_inpuaa == "黄金9995") {
          //如果三栏是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpric = (Number(this.tabs_iaa) / Number(this.tabs_inaa)).toFixed(2); //计算第第一栏的单价
              this.tabs_zeaa =
                (
                  Number(this.tabs_iaa) /
                  Number(this.tabs_inaa) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpuaa == "铂金9995") {
          //如果第三栏时铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.dpric = (Number(this.tabs_iaa) / Number(this.tabs_inaa)).toFixed(2); //计算第第一栏的单价
              this.tabs_zeaa =
                (
                  Number(this.tabs_iaa) /
                  Number(this.tabs_inaa) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果非黄金铂金时
          this.dpric = (Number(this.tabs_iaa) / Number(this.tabs_inaa)).toFixed(2); //计算第第一栏的单价
          this.tabs_zeaa = "0";
        }
      }
    },

    //回收根据价格计算单价和折当率
    twosInput(dats) {
      //如果选择的是黄金9999时

      //回收单价计算折当率
      if (dats == "tabs_ins" && this.tabs_ins !== "") {
        //如果输入的是第一栏时且重量不为空时
        if (this.tabs_inpus == "黄金9999") {
          //如果第一栏输入的是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpria = (Number(this.tabs_is) / Number(this.tabs_ins)).toFixed(2); //计算第第一栏的单价
              this.hs_ze =
                (
                  Number(this.tabs_is) /
                  Number(this.tabs_ins) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpus == "黄金9995") {
          //如果第一栏输入的是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpria = (Number(this.tabs_is) / Number(this.tabs_ins)).toFixed(2); //计算第第一栏的单价
              this.hs_ze =
                (
                  Number(this.tabs_is) /
                  Number(this.tabs_ins) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpus == "铂金9995") {
          //如果第一栏输入的是铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpria = (Number(this.tabs_is) / Number(this.tabs_ins)).toFixed(2); //计算第第一栏的单价
              this.hs_ze =
                (
                  Number(this.tabs_is) /
                  Number(this.tabs_ins) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果第一栏输入的是其他时
          this.hpria = (Number(this.tabs_is) / Number(this.tabs_ins)).toFixed(2); //计算第第一栏的单价
          this.hs_ze = 0;
        }
      } else if (dats == "tabs_insa" && this.tabs_insa !== "") {
        //如果输入的是第二栏时且重量不为空时
        if (this.tabs_inpusa == "黄金9999") {
          //如果第二栏输入的是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hprib = (Number(this.tabs_isa) / Number(this.tabs_insa)).toFixed(2); //计算第第二栏的单价
              this.hs_zea =
                (
                  Number(this.tabs_isa) /
                  Number(this.tabs_insa) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpusa == "黄金9995") {
          //如果第二栏输入的是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hprib = (Number(this.tabs_isa) / Number(this.tabs_insa)).toFixed(2); //计算第第二栏的单价
              this.hs_zea =
                (
                  Number(this.tabs_isa) /
                  Number(this.tabs_insa) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpusa == "铂金9995") {
          //如果第二栏输入的是铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hprib = (Number(this.tabs_isa) / Number(this.tabs_insa)).toFixed(2); //计算第第二栏的单价
              this.hs_zea =
                (
                  Number(this.tabs_isa) /
                  Number(this.tabs_insa) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果第二栏输入的是其他时
          this.hprib = (Number(this.tabs_isa) / Number(this.tabs_insa)).toFixed(2); //计算第第二栏的单价
          this.hs_zea = 0;
        }
      } else if (dats == "tabs_insaa" && this.tabs_insaa !== "") {
        //如果输入的是第三栏时且重量不为空时

        if (this.tabs_inpusaa == "黄金9999") {
          //如果第三栏输入的是黄金9999时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1053",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpric = (Number(this.tabs_isaa) / Number(this.tabs_insaa)).toFixed(2); //计算第第三栏的单价
              this.hs_zeaa =
                (
                  Number(this.tabs_isaa) /
                  Number(this.tabs_insaa) /
                  rd.data.result.dtList[1053].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpusaa == "黄金9995") {
          //如果第三栏输入的是黄金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1054",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpric = (Number(this.tabs_isaa) / Number(this.tabs_insaa)).toFixed(2); //计算第第三栏的单价
              this.hs_zeaa =
                (
                  Number(this.tabs_isaa) /
                  Number(this.tabs_insaa) /
                  rd.data.result.dtList[1054].last_price
                ).toFixed(2) * 100;
            });
        } else if (this.tabs_inpusaa == "铂金9995") {
          //如果第三栏输入的是铂金9995时
          this.axios
            .get("/getGold/?app=finance.gold_price", {
              params: {
                goldid: "1056",
                version: 3,
                appkey: "62349",
                sign: "2b467d69432566985eec8e93f82e9008",
                format: "json",
              },
            })
            .then((rd) => {
              this.hpric = (Number(this.tabs_isaa) / Number(this.tabs_insaa)).toFixed(2); //计算第第三栏的单价
              this.hs_zeaa =
                (
                  Number(this.tabs_isaa) /
                  Number(this.tabs_insaa) /
                  rd.data.result.dtList[1056].last_price
                ).toFixed(2) * 100;
            });
        } else {
          //如果第三栏输入的是其他时
          this.hpric = (Number(this.tabs_isaa) / Number(this.tabs_insaa)).toFixed(2); //计算第第三栏的单价
          this.hs_zeaa = 0;
        }
      }
    },

    //规格下拉搜索
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

    //

    //下拉列表
    loadAll() {
      return [
        { value: "黄金9999" },
        { value: "黄金9995" },
        { value: "铂金9995" },
        { value: "K金" },
        { value: "银" },
        { value: "钯金" },
        { value: "手表" },
        { value: "电子产品" },
        { value: "其他" },
      ];
    },

    //发送模板消息
    sendInform() {},

    //身份证失去焦点查找事件
    async IdCardBlur() {
      //不等于空就执行查找
      if (this.input_idcard !== "") {
        let newDatsa = await this.getIdCardData(this.input_idcard);

        if (newDatsa.data.length >= 1) {
          this.input_name = newDatsa.data[newDatsa.data.length - 1].name;
          this.input_tel = newDatsa.data[newDatsa.data.length - 1].telnumber;
          this.input_add = newDatsa.data[newDatsa.data.length - 1].address;
          this.getDadData(this.input_idcard);
        } else {
          (this.input_name = ""), (this.input_tel = ""), (this.input_add = "");

          this.$notify({
            title: "温馨提示",
            message: "该客户第一次建当，未查询到该客户的典当记录",
            type: "warning",
          });
        }
      } else {
        (this.input_name = ""), (this.input_tel = ""), (this.input_add = "");
      }
    },
    //通过身份证号查找会员信息
    async getIdCardData(event) {
      let newData = [];

      await this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").where({
                        cardnumber:_.eq("${event}")
                    }).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          newData = res.data;
        });

      return newData;
    },

    //查找历史典当
    async GetHistory() {
      if (this.input_idcard !== "") {
        this.newHistoryList = await this.getIdCardData(this.input_idcard);
        if (this.newHistoryList.data.length > 0) {
          this.dialogTableVisible = !this.dialogTableVisible;
        } else {
          this.$notify({
            title: "温馨提示",
            message: "该客户没有历史典当记录",
            type: "warning",
          });
        }
      } else {
        this.$notify({
          title: "温馨提示",
          message: "请输入身份证号",
          type: "warning",
        });
      }
    },
    //查找历史典当弹窗关闭事件
    handleClose() {
      this.dialogTableVisible = false;
    },

    //接收历史典当子组件的传值
    childData(data) {
      this.input_wu = data.itemname; //物品种类

      this.tabs_input = data.objname; //第一栏当物名称
      this.tabs_inputa = data.objnamea; //2
      this.tabs_inputaa = data.objnameaa; //3

      this.tabs_inpu = data.speci; //规格
      this.tabs_inpua = data.specia; //2
      this.tabs_inpuaa = data.speciaa; //3

      this.tabs_inp = data.num; //数量
      this.tabs_inpa = data.numa; //2
      this.tabs_inpaa = data.numaa; //3

      this.tabs_in = data.weig; //重量
      this.tabs_ina = data.weiga; //2
      this.tabs_inaa = data.weigaa; //3

      this.tabs_i = data.pric; //典当价格
      this.tabs_ia = data.prica; //2
      this.tabsiaa = data.pricaa; //3

      this.dpria = data.unitpricea; //典当单价
      this.dprib = data.unitpriceaa; //2
      this.dpric = data.unitpriceaaa; //3

      this.tabs_ze = data.rate; //折当率
      this.tabs_zea = data.ratea; //2
      this.tabs_zeaa = data.rateaa; //3

      this.dialogTableVisible = false;
    },

    getDadData(event) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("badData").where({idcard:"${event}"}).limit(1000).get()`,
        })
        .then(async (res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          if (res.data.data.length > 0) {
            this.dialogTableDad = true;
            //弹窗显示
            this.badData = res.data.data;
          } else {
            //不弹窗显示
            this.dialogTableDad = false;
            this.badData = [];
          }
        });
    },
    DadClose() {
      this.dialogTableDad = false;
      this.badData = [];
    },

    // 点击tab栏切换
    TabClick(event) {
      if (event.index == 1) {
        this.getPnumber();
      }
    },

    //回收的票号
    getPnumber() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").where({reviewdate:"${dayjs().format(
            "YYYY-MM-DD"
          )}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          let total = 0;
          if (res.data.pager.Total + 1 > 9) {
            total = res.data.pager.Total + 1;
          } else {
            total = "0" + (res.data.pager.Total + 1);
          }

          this.input_pnum = "D" + dayjs().format("YYMMDD") + total;
        });
    },

    getPawnCode() {
      let { licence, userid, password } = this.$store.state;

      console.log("6666", licence, userid, password);

      if (userid !== "" && userid !== undefined) {
        let requierData = {
          head: { name: userid, password: password },
          body: { permitCode: licence, transactionType: "1" },
        };
        console.log(requierData);
        // let requierData = JSON.stringify({
        //   head: { name: userid, password: password },
        //   body: { permitCode: licence, transactionType: 1 },
        // });
        //请求票号数据加密
        // this.axios
        //   .post("/encryptData/apis/postTest", {
        //     requierData,
        //   })
        //   .then((res) => {
        //     console.log(res);
        //   });
        // this.axios.get("/encryptData/apis/test").then((res) => {
        //   console.log("加密数据", res);
        // });
        // this.axios.get("/send/test").then((res) => {
        //   console.log(res);
        // });
        this.axios({
          method: "POST", //请求方式
          url: "/encryptData/apis/postTest", //路径
          headers: { "Content-Type": "application/json-patch+json" },
          data: JSON.stringify(requierData),
        }).then((res) => {
          console.log(res);
        });
      } else {
        this.$notify({
          title: "警告",
          message: "未配置企业端信息，数据无法同步至企业端",
          type: "warning",
        });
      }
    },
  },

  //生命周期函数，监听页面创建时
  created() {
    this.deta = dayjs().format("YYYY-MM-DD HH:mm");

    // this.input_pnum = "D" + dayjs().format("MMDDHHmms");

    //请求公众号的token

    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },

  mounted() {
    // this.getPawnCode();

    setTimeout(() => {
      // get请求获取access_token

      //获取登录用户的名字
      this.agent = this.userData.username;

      //调用下拉获取列表
      this.restaurants = this.loadAll();
    }, 900);
  },
};
</script>
<style scoped>
.cont_box {
  width: 95%;
  height: 95%;
  background-color: #ffffff;
  margin: 50px auto;
}
.cont_head {
  width: 100%;
  height: 40px;
  background-color: #eeeeed;
  box-shadow: 0 0 9px 0 #00000044;
  border: 1px solid #c5c5c5;
}
.cont_head h2 {
  margin: 3px 30px;
}
.bord {
  border: 0.5px solid #c5c5c5;
  margin-top: 4px;
}
.cont_bo {
  width: 100%;
  height: 95%;
  border: 1px solid #c5c5c5;
  /* box-shadow: 0 0 3px 0 #000000; */
}
.cont_b {
  width: 99%;
  height: 99%;
  border: 1px solid #c5c5c5;
  margin: 4px auto;
  box-shadow: 0 0 9px 0 #00000044;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.cont_input {
  width: 60%;
}
.row_t {
  border-bottom: 2px double #000000;
  width: 35%;
  margin: 4px 0;
}
.cont_deta {
  width: 50%;
}
.cont_de {
  width: 50%;
}
.cont_content {
  border: 1px solid #8f8f8fdc;
  box-shadow: 0 0 9px 0 #00000044;
  width: 98%;
  padding: 15px 0;
  margin: 0 auto;
}
.con {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
}
.cont_left {
  width: 55%;
}
.cont_right {
  width: 45%;
}
.con_texts {
  width: 40%;
}
.tables {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}
.tab_item {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.tables_inps {
  margin: 10px 0;
  width: 65%;
}

.cont_des {
  margin: 20px 20px;
}
.block {
  width: 95%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin: 40px 0;
}
.de_text {
  margin: 0 220px;
  margin-right: 10px;
}
.de_texts {
  margin: 0 190px;
  margin-right: 10px;
}
.price {
  margin: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.bank_zh {
  width: 25%;
}
.cont_jb {
  margin: 10px 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.cont_jbs {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.photo {
  margin: 10px 20px;
}
.foter {
  margin: 30px 30px;
}
.con_rate {
  margin-left: 20px;
}
.con_rates {
  margin: 0 15px;
}
.con_cost {
  width: 100%;
  display: flex;
  flex-direction: row;
  /* margin: 0 15px; */
  /* justify-content: space-between; */
}
.con_costo {
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.con_costt {
  width: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.con_elinp {
  width: 50%;
  /* margin: -8px 20px; */
}
.fl {
  margin: 0 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* 断当回收样式 */
.cont_contes {
  width: 98%;
  border: 1px solid #8f8f8fdc;
  box-shadow: 0 0 9px 0 #00000044;
  margin: 6px auto;
}
.cons_cos {
  display: flex;
  flex-direction: row;
}
.cont_lefts {
  width: 50%;
  margin: 40px 80px;
}
.cont_rights {
  width: 50%;
  margin: 40px 0px;
}
.conts_zf {
  margin: 20px 0;
  display: flex;
  flex-direction: row;
}
.conts_zf h3 {
  margin: 10px 25px;
}
.cont_zfin {
  width: 800px;
}
.tas {
  width: 50%;
}

/* 鉴定评估 */
.cont_jdf {
  width: 200px;
}
/* 建当评估意见 */
.con_y {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 20px;
}
/* 建当评估意见 */
.con_yj {
  width: 60%;
  margin: 0 20px;
}

.total {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  /* margin-right: 15%; */
}
.total span {
  /* margin-right: 20px; */
  font-size: 18px;
  font-weight: bold;
}
.tota_span {
  color: #bd3333;
}
.connai span {
  color: #4c37b2;
}
.conn span {
  font-weight: bolder;
  color: #4c37b2;
}
table {
  border-collapse: collapse;
}
th,
td {
  /* width: 100%; */
  height: 50px;
  /* border: 1px solid #a7a7a7; */
  font-size: 14px;
  text-align: center;
}
.con_upload {
  width: 90%;
  margin: 0 auto;
}

.connai {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.conn {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.tes {
  margin: 20px 10px;
  color: #757575;
}
.zon {
  width: 90%;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: end;
  font-size: 20px;
  font-weight: bold;
  color: #bd3333;
}
/* .row_te {
  text-decoration: underline;
} */
</style>
